import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { FormattedMessage } from 'react-intl';

export class SuccessSyncModal extends React.Component {
  render () {
    const { changeModal, showModal } = this.props;
    return (
      <BootstrapModal
        showModal={showModal}
        header={
          <div>
            <i className="ico-lg text-green icon-confirmed-check" />
            <h3>
              <FormattedMessage
                id="hosting.modal_sync_cal_success.header"
                defaultMessage="Your calendar has {break} successfully been connected"
                values={{
                  break: <br />
                }}
              />
            </h3>
          </div>
        }
        body={
          <div className="margin-xxl-bottom">
            {/* TEMPORARY FIX - removing export button, text was swapped out for a version that does not mention sharing calendar */}
            {/* <p className="margin-xxl-bottom" >
              <FormattedMessage
                id="hosting.modal_sync_cal_success.body"
                defaultMessage="Syncing can take up to 60 seconds.  Refresh your browser to view your sync status."
              />
            </p> */}
            {/* <button
              onClick={() => changeModal('')}
              className="btn btn-primary btn-block classic"
            >
              <FormattedMessage
                id="hosting.modal_sync_cal_success.button_text"
                defaultMessage="View Sync Status"
              />
            </button> */}
          </div>
        }
        bodyClass="sync-modal-body text-center"
        toggleModal={changeModal}
      />
    );
  }
}

SuccessSyncModal.propTypes = {
  showModal: PropTypes.bool,
  changeModal: PropTypes.func
};
